import {listener, removeClass, removeElement} from "../../../../../../../modules/vegas/js/util";
import VGCatalogCart from "./cart";

const cart = new VGCatalogCart();

function listeners() {
	// удаляем из списка товаров
	listener('click', '[data-product-item] [data-cart][data-action=del]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product-item]');
		if (product) {
			cart.remove(product, function () {
				removeClass(product, 'in-cart');
			});
		}
	});
	listener('click', '[data-product-item] [data-qty="trash"]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product-item]');
		if (product) {
			cart.remove(product, function () {
				removeClass(product, 'in-cart');
			});
		}
	});

	// удаляем со страницы товара
	listener('click', '[data-product] [data-cart][data-action=del]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product]');
		if (product) {
			cart.remove(product, function () {
				removeClass(product, 'in-cart');
			});
		}
	});
	listener('click', '[data-product] [data-qty=trash]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product]');
		if (product) {
			cart.remove(product, function () {
				removeClass(product, 'in-cart');
			});
		}
	});

	// удаляем товар на странице "Корзина"
	listener('click', '[data-product-cart-item] [data-cart][data-action="del"]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product-cart-item]');
		if (product) {
			cart.remove(product, function (data) {
				removeElement(product);

				if (!data.products_count) {
					if (window.Turbo) {
						Turbo.visit(location.href);
					} else {
						location.reload();
					}
				}
			});
		}
	});
}

document.addEventListener('DOMContentLoaded', listeners);
